// ── SpotterPopup ─────────────────────────────────────────────────────────────
// Compact floating card shown when a spotter marker or report marker is clicked.
// Reuses existing .sa-md-popup / .sa-md-header / .sa-md-body chrome; only
// spotter-specific chip styles live in SpotterPopup.css.

import "./SpotterPopup.css";
import { REPORT_CONFIG, REPORT_SOURCES } from "../data/spotterNetwork";

function fmtTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false }) + " Z";
}

function fmtAge(iso) {
  if (!iso) return "";
  const mins = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (mins < 1)  return "just now";
  if (mins < 60) return `${mins} min ago`;
  return `${Math.floor(mins / 60)}h ${mins % 60}m ago`;
}

export default function SpotterPopup({ spotter, report, pos, onClose }) {
  if ((!spotter && !report) || !pos) return null;

  const isSpotter = !!spotter;
  const title = isSpotter
    ? spotter.name
    : (REPORT_CONFIG[report.type]?.label ?? report.type);

  return (
    <div
      className="sa-md-popup sa-spotter-popup"
      style={{ left: pos.left, top: pos.top }}
    >
      <div className="sa-md-header">
        <span>{title}</span>
        <button
          type="button"
          className="sa-warn-card-close"
          onClick={onClose}
          aria-label="Close"
        >
          <svg viewBox="0 0 12 12" fill="none" width="10" height="10" aria-hidden="true">
            <line x1="1" y1="1" x2="11" y2="11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            <line x1="11" y1="1" x2="1" y2="11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
          </svg>
        </button>
      </div>

      <div className="sa-md-body">
        {isSpotter && (
          <>
            <div className="sa-spotter-chips">
              <span className={`sa-spotter-chip ${spotter.status === "Chasing" ? "sa-spotter-chip--active" : "sa-spotter-chip--idle"}`}>
                {spotter.status}
              </span>
              {spotter.verified === 1 && (
                <span className="sa-spotter-chip sa-spotter-chip--verified">Verified</span>
              )}
            </div>
            <div className="sa-metar-row sa-metar-row--muted">
              {fmtTime(spotter.lastUpdated)}
            </div>
          </>
        )}

        {!isSpotter && (
          <>
            <div className="sa-spotter-chips">
              {report.source && REPORT_SOURCES[report.source] && (
                <span className={`sa-spotter-chip sa-spotter-chip--source sa-spotter-chip--source-${report.source}`}>
                  {REPORT_SOURCES[report.source].label}
                </span>
              )}
              <span className={`sa-spotter-chip sa-spotter-chip--sev-${report.severity}`}>
                {report.severity}
              </span>
            </div>
            <div className="sa-metar-row">By {report.spotterName}</div>
            {report.note && (
              <div className="sa-metar-row sa-metar-row--secondary">{report.note}</div>
            )}
            <div className="sa-metar-row sa-metar-row--muted">
              {fmtAge(report.createdAt)}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
